
	import { Component, Vue } from 'vue-property-decorator';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';
	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({
		components: { ViewportWrapper }
	})
	export default class TheHelpCenterLink extends Vue {
		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected get helpCenterArticleTitle(): string {
			return helpCenterServiceModule.articleTitle;
		}

		protected openHelpCenter(): void {
			helpCenterServiceModule.setIsHelpCenterOpened(true);
		}
	}
